export enum ExpectedUsage {
    NotApplicable = 'notApplicable',
    Centralized = 'centralized',
    OnPremiseDataRecipient = 'onPremiseDataRecipient',
    OnPremiseDataProvider = 'onPremiseDataProvider',
}

export const ExpectedUsageText = {
    [ExpectedUsage.NotApplicable]: 'Not applicable',
    [ExpectedUsage.Centralized]: 'In the Centralized Data Spaces',
    [ExpectedUsage.OnPremiseDataRecipient]: 'In the Federated Data Recipient’s Data Space',
    [ExpectedUsage.OnPremiseDataProvider]: 'In the Federated Data Provider’s Data Space only',
};

export const ExpectedUsageShortText = {
    [ExpectedUsage.NotApplicable]: 'Not applicable',
    [ExpectedUsage.Centralized]: 'Centralized',
    [ExpectedUsage.OnPremiseDataRecipient]: 'Data Recipient’s Data Space',
    [ExpectedUsage.OnPremiseDataProvider]: 'Data Provider’s Data Space',
};
